import { DueDisplayOptions, Task } from '@griply/types';
import {
  getTaskDueAndTimeslot,
  GetTaskDueAndTimeslotOptions,
  TaskDueAndTimeslot,
} from '@griply/utils';
import { useMemo } from 'react';

const allDueDisplayOptions = Object.values(DueDisplayOptions);

export type UseTaskDueAndTimeslotOptions = GetTaskDueAndTimeslotOptions;

export type { TaskDueAndTimeslot };

export const useTaskDueAndTimeslot = (
  task: Task,
  {
    today,
    weekStartsOn,
    displayDate,
    displayDue = allDueDisplayOptions,
  }: UseTaskDueAndTimeslotOptions,
): TaskDueAndTimeslot =>
  useMemo(
    () =>
      getTaskDueAndTimeslot(task, {
        today,
        weekStartsOn,
        displayDate,
        displayDue,
      }),
    [task, today, weekStartsOn, displayDate, displayDue],
  );
